// Feature flags build-time (VUE_APP_*). Default: off (oculto) salvo string 'true' exacta.
export const featureLevelHistory = process.env.VUE_APP_FEATURE_LEVEL_HISTORY === 'true';
export const featureSupportRequests = process.env.VUE_APP_SUPPORT_REQUESTS_ENABLED === 'true';
